// extracted by mini-css-extract-plugin
export default {"container":"FilterCategories_container__TLSp5","categories":"FilterCategories_categories__w0FbD","loading":"FilterCategories_loading__0SSRF"};